module.exports = __webpack_public_path__ + "media/documents/plakat_lokale-120570e02ff9fb398189f3141d6f4394.pdf";